import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { useMemo } from 'react';

export function useCheckUpgradeForIntegration() {
  const { data } = useCurrentSubscriptionApi();

  const checkUpgradeForIntegration = useMemo(() => {
    return !data?.entitlements?.find(
      (x) => x.metadata.parent === 'Integrations'
    );
  }, [data?.entitlements]);
  return checkUpgradeForIntegration;
}
